import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { StatusHistoryModel } from '../../../../store/models/status-history.model';
import { DISPLAY_DATE_FORMAT } from '../../../../common/constants/date-config';
import { StatusAcceptanceType } from '../../../../store/constants';
import { PlannedTimeModel } from '../../../../store/models/planned-time.model';
import { IconNames } from '../../../../common/constants';

@Component({
  selector: 'lib-status-history',
  templateUrl: './status-history.component.html',
  styleUrls: ['./status-history.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StatusHistoryComponent {
  @Input() statuses: Array<StatusHistoryModel | PlannedTimeModel>;
  @Input() columnTitles?: string[];
  @Input() isDefaultTitleIconVisible = true;
  statusAcceptanceType = StatusAcceptanceType;
  dateFormat = DISPLAY_DATE_FORMAT;
  iconNameList = IconNames;
}
